import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { QueryStatus } from '@reduxjs/toolkit/query';

import { useGetAppConfigQuery } from 'shared/api/commonApi';
import { debounce } from 'shared/utils/debounce';

import { useSetReadMutation } from '../api/api';
import { CONFIG } from '../consts/config';
import { setReadNotifications } from '../model/notificationsSlice';

const debounsedSetRead = debounce((args) => {
	const [callback] = args as [() => void];
	callback();
}, CONFIG.READ_DEBOUNCE);

export const useReadNotifications = () => {
	const { data: appConfig } = useGetAppConfigQuery();
	const [viewedNotifications, setViewedNotifications] = useState(new Set<number>());
	const [setRead, { status }] = useSetReadMutation();
	const dispatch = useDispatch();

	useEffect(() => {
		if (status === QueryStatus.fulfilled) {
			setViewedNotifications(new Set<number>());
		}
	}, [status]);

	useEffect(() => {
		if (viewedNotifications.size > 0 && !appConfig?.is_super_login) {
			debounsedSetRead(() => {
				setRead({ ids: [...viewedNotifications] });
				dispatch(setReadNotifications([...viewedNotifications]));
			});
		}
	}, [viewedNotifications, setRead, dispatch, appConfig?.is_super_login]);

	return {
		appendReadNotification: useCallback((id: number) => {
			setViewedNotifications((prevState) => new Set([...prevState, id]));
		}, []),
		setRead,
		viewedNotifications,
	};
};
